import { SkeletonContent, SkeletonLine, Typography, } from '@one-thd/sui-atomic-components';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { quickbooksSync } from '../api/oms/order-history';
import { BopisOutOfStockRecoveryAlert } from '../components/purchase-history/bopis-out-of-stock-recovery-alert/BopisOutOfStockRecoveryAlert';
import { BuyItAgain } from '../components/purchase-history/buy-it-again/BuyItAgain';
import { CardAndTableView } from '../components/purchase-history/CardAndTableView';
import { CPSAnnouncementBanner } from '../components/purchase-history/cps-announcement-banner/CPSAnnouncementBanner';
import { MissingPurchase } from '../components/purchase-history/MissingPurchase';
import { OrderFilter } from '../components/purchase-history/order-filter/OrderFilter';
import { OrderSearch } from '../components/purchase-history/order-search/OrderSearch';
import { OrderViewToggle } from '../components/purchase-history/order-view-toggle/OrderViewToggle';
import { AddReceiptButton } from '../components/purchase-history/page-header/AddReceiptButton';
import { OrderHistoryHeader } from '../components/purchase-history/page-header/OrderHistoryHeader';
import { PTCInfoBanner } from '../components/purchase-history/ptc-info-banner/PTCInfoBanner';
import { SortAndSearch } from '../components/purchase-history/sort-and-search/index';
import { PHTableSettingsTile } from '../components/purchase-history/table-view/index';
import { AlertBanner } from '../components/shared/alert-banner/AlertBanner';
import PageLayout from '../components/shared/PageLayout';
import { PHXSatisfactionSurvey } from '../components/shared/PHXSatisfactionSurvey';
import { SpendingTotals } from '../components/total-perks-spend/SpendingTotals';
import { SpendOverview } from '../components/total-perks-spend/SpendOverview';
import { FeatureSwitches } from '../constants/feature-switches';
import { OrderHistoryModalHooks } from '../hooks/purchase-history-hooks';
import { useCommonContext, useExperienceContext, usePurchaseHistoryContext, } from '../hooks/useContexts';
import { getWindow } from '../utils/general';
import { setPurchaseHistoryPageAnalytics, setQBSyncError, } from '../utils/purchase-history/analytics';
import '../components/purchase-history/table-view/ButtonGroup.scss';
import '../styles/order-history.scss';
// TODO: Remove /* eslint-disable max-lines */ from all files 🚨
/**
 * @param alertState
 * @param qbAlertState
 * @returns Element that holds the alert banners for the purchase history page
 */
var AlertBanners = function (alertState, qbAlertState) { return (React.createElement(React.Fragment, null, (alertState || qbAlertState) && (React.createElement("div", { className: "sui-col-span-1 sui-max-w-[1039px]" },
    React.createElement(AlertBanner, { headline: (alertState === null || alertState === void 0 ? void 0 : alertState.alertTitle) || (qbAlertState === null || qbAlertState === void 0 ? void 0 : qbAlertState.alertTitle) || '', status: (alertState === null || alertState === void 0 ? void 0 : alertState.status) || (qbAlertState === null || qbAlertState === void 0 ? void 0 : qbAlertState.status) || 'info', onClose: (alertState === null || alertState === void 0 ? void 0 : alertState.onClose) || (qbAlertState === null || qbAlertState === void 0 ? void 0 : qbAlertState.onClose) }, (alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage) || (qbAlertState === null || qbAlertState === void 0 ? void 0 : qbAlertState.alertMessage)))))); };
export var PurchaseHistory = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _k, _l;
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var _m = useSearchParams(), searchParams = _m[0], setSearchParams = _m[1];
    var _o = useCommonContext(), isMobile = _o.isMobile, isTablet = _o.isTablet, isDesktop = _o.isDesktop;
    var _p = usePurchaseHistoryContext(), alertState = _p.alertState, setAlertState = _p.setAlertState, orderHistoryData = _p.orderHistoryData, orderHistoryError = _p.orderHistoryError, orderHistoryLoaded = _p.orderHistoryLoaded, viewType = _p.viewType, dateSelectorValue = _p.dateSelectorValue, pHRequest = _p.pHRequest, cpsDataSource = _p.cpsDataSource, allOrderDetails = _p.allOrderDetails;
    var svocID = useThdCustomer().svocID;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var crumbs = useAccountCrumbs([
        {
            label: 'Purchase History',
            path: '/myaccount/purchase-history',
        },
    ]);
    var orderHistoryModalHooks = OrderHistoryModalHooks();
    var _q = useState(false), enableSettingsDrawer = _q[0], setEnableSettingsDrawer = _q[1];
    var _r = useState(null), qbAlertState = _r[0], setQBAlertState = _r[1];
    var _s = useState(''), searchText = _s[0], setSearchText = _s[1];
    useEffect(function () {
        setPurchaseHistoryPageAnalytics();
        var authCode = searchParams.get('qb_auth_code');
        var realmId = searchParams.get('qb_realm_id');
        var qbState = searchParams.get('qb_state');
        var qbCancel = searchParams.get('cancel');
        if (authCode && realmId && qbState) {
            var request = {
                quickBooksSyncRequest: {
                    qbState: qbState,
                    qbRealmId: realmId,
                },
            };
            quickbooksSync(request, authCode)
                .then(function () {
                // set successful banner
                setQBAlertState({
                    alertMessage: 'Your Quickbooks account has been successfully synced.',
                    status: 'success',
                    onClose: function () { return setQBAlertState(null); },
                });
            })
                .catch(function (error) {
                // set error banner
                setQBSyncError(error);
                setQBAlertState({
                    alertMessage: 'There was an issue syncing your Quickbooks account, please try again.',
                    status: 'error',
                });
            })
                .finally(function () {
                searchParams.delete('qb_auth_code');
                searchParams.delete('qb_realm_id');
                searchParams.delete('qb_state');
                setSearchParams(searchParams);
            });
        }
        if (qbCancel) {
            searchParams.delete('cancel');
            setSearchParams(searchParams);
        }
    }, []);
    var poUpdatedOrderHistory = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.getItem('purchaseHistory-poJobUpdate')) || null;
    /**
     * TBD - ? what is this for
     */
    if ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) && poUpdatedOrderHistory) {
        var parsedPOUpdatedOrderHistory = JSON.parse(poUpdatedOrderHistory);
        for (var i = 0; i < (parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory.length); i += 1) {
            for (var _j = 0; _j < orderHistoryData.orders.length; _j += 1) {
                if (((_d = (_c = parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory[i]) === null || _c === void 0 ? void 0 : _c.orderNumbers) === null || _d === void 0 ? void 0 : _d[0]) ===
                    ((_g = (_f = (_e = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _e === void 0 ? void 0 : _e[_j]) === null || _f === void 0 ? void 0 : _f.orderNumbers) === null || _g === void 0 ? void 0 : _g[0]) &&
                    ((_h = parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory[i]) === null || _h === void 0 ? void 0 : _h.totalAmount) ===
                        ((_l = (_k = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _k === void 0 ? void 0 : _k[_j]) === null || _l === void 0 ? void 0 : _l.totalAmount)) {
                    orderHistoryData.orders[_j] = parsedPOUpdatedOrderHistory[i];
                }
            }
        }
    }
    useEffect(function () {
        var _a;
        if (orderHistoryData) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('orderHistory', JSON.stringify(orderHistoryData));
        }
    }, [orderHistoryLoaded, orderHistoryData]);
    useEffect(function () {
        var _a;
        if (((_a = orderHistoryError === null || orderHistoryError === void 0 ? void 0 : orderHistoryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
        }
    }, [orderHistoryError]);
    var searchEnabled = pHRequest.searchBy !== undefined;
    var showSpendingTotal = orderHistoryLoaded &&
        customerType === 'b2b' &&
        (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId);
    return (React.createElement(PageLayout, { crumbs: crumbs, customerRole: customerRole, customerType: customerType, headerComponent: React.createElement(OrderHistoryHeader, null), internalRoutes: ['/myaccount/order-history'], isMobile: isMobile, pageTitle: "Purchase History" },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-gap-3 sui-max-w-[1039px]" },
                customerType === 'b2b' && cpsDataSource === 'CPS' && (React.createElement(CPSAnnouncementBanner, null)),
                FeatureSwitches.enableBopisOutOfStockRecoverability && (React.createElement(BopisOutOfStockRecoveryAlert, { allOrderDetails: allOrderDetails }))),
            React.createElement("div", { className: "sui-isolation-auto sui-max-w-[1039px]" },
                React.createElement(PHXSatisfactionSurvey, null)),
            ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || 0) > 1 &&
                customerType === 'b2b' &&
                FeatureSwitches.ptcBectran && (React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-mb-6 sui-max-w-[1039px]" },
                React.createElement(ErrorBoundary, { name: "ptc-info-banner" },
                    React.createElement(QueryProvider, { cacheKey: "loyalty-benefits-cacheKey" },
                        React.createElement(PTCInfoBanner, null))))),
            React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-gap-6 sui-max-w-[1039px]" },
                !FeatureSwitches.enableNewLoyaltySpendUI && showSpendingTotal && (React.createElement("div", { className: "md:sui-flex sui-justify-end sui-hidden" },
                    React.createElement(ErrorBoundary, { name: "total-spend" },
                        React.createElement(SpendingTotals, null)))),
                ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || 0) > 1 &&
                    customerType === 'b2b' && (React.createElement("div", { className: "sui-col-span-1  ".concat(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI
                        ? 'lg:sui-flex lg:sui-gap-[31px]'
                        : '', " ").concat(isConsumerApp ? '' : 'sui-mb-[24px] md:sui-mb-0', " sui-max-w-[1039px]") },
                    React.createElement(ErrorBoundary, { name: "buy-it-again" },
                        React.createElement(BuyItAgain, null)),
                    isDesktop && FeatureSwitches.enableNewLoyaltySpendUI && (React.createElement(ErrorBoundary, { name: "spend-overview" },
                        React.createElement(SpendOverview, null))))),
                viewType !== 'LocalDeliveries' ? (React.createElement("div", { className: "no-print sui-col-span-1 sui-max-w-[1039px]" },
                    React.createElement("div", { className: "sui-flex sui-flex-row" },
                        React.createElement(ErrorBoundary, { name: "sort-and-search" }, (function () {
                            if (FeatureSwitches.enableCPSSearch &&
                                cpsDataSource === 'CPS' &&
                                orderHistoryLoaded) {
                                return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-5 sui-w-full md:sui-mb-0" },
                                    isMobile && (React.createElement(AddReceiptButton, { svocId: svocID, mobile: true })),
                                    React.createElement("div", { className: "sui-mb-[16px] sui-flex sui-w-full sm:sui-mb-0" },
                                        React.createElement(OrderSearch, { searchText: searchText, setSearchText: setSearchText }),
                                        React.createElement(OrderFilter, null))));
                            }
                            if (orderHistoryLoaded) {
                                return (React.createElement(SortAndSearch, { orderCount: orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount }));
                            }
                            return (React.createElement("div", { className: "sui-flex sui-w-full" },
                                React.createElement(SkeletonContent, { initialSize: "full", disablePadding: "x" },
                                    React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }))));
                        })()),
                        customerType === 'b2c' && !isMobile && (React.createElement("div", { className: "sui-hidden md:sui-flex md:sui-self-center md:sui-pt-6" },
                            React.createElement(MissingPurchase, null)))))) : (React.createElement("div", null)),
                React.createElement("div", { className: "no-print sui-hidden md:sui-flex md:sui-items-center lg:sui-flex lg:sui-items-center sui-col-span-1 sui-justify-between sui-max-w-[1039px]" },
                    React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between" }, customerType !== 'b2c' && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "sui-flex sui-items-center" },
                            React.createElement(ErrorBoundary, { name: "order-view-toggle" },
                                React.createElement(QueryProvider, { cacheKey: "loyalty-benefits-cacheKey" },
                                    React.createElement(OrderViewToggle, null))),
                            !isMobile && React.createElement(MissingPurchase, null)),
                        viewType === 'Table' && !searchEnabled && (React.createElement(ErrorBoundary, { name: "table-customization" },
                            React.createElement(PHTableSettingsTile, { setEnableSettingsDrawer: setEnableSettingsDrawer }))))))),
                AlertBanners(alertState, qbAlertState),
                cpsDataSource === 'CPS' && (React.createElement("div", { style: {
                        backgroundColor: 'rgb(243, 243, 243)',
                        textAlign: 'center',
                        padding: '6px 0',
                        marginBottom: isMobile || isTablet ? '8px' : '-12px',
                        marginTop: isMobile || isTablet ? '0px' : '-12px',
                        maxWidth: '1039px',
                    } },
                    React.createElement(Typography, { variant: "body-sm", color: "inactive" }, (function () {
                        var _a, _b;
                        var phFilter = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem('PHFilter');
                        var sessionPHFilter = phFilter
                            ? JSON.parse(phFilter)
                            : undefined;
                        if (((sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) || dateSelectorValue) ===
                            'custom') {
                            var startDate = pHRequest.startDate.split('-');
                            var endDate = pHRequest.endDate.split('-');
                            return (sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.startDate) &&
                                (sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.endDate)
                                ? "".concat(sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.startDate, " - ").concat(sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.endDate)
                                : "".concat(startDate[1], "/").concat(startDate[2], "/").concat(startDate[0], " - ").concat(endDate[1], "/").concat(endDate[2], "/").concat(endDate[0]);
                        }
                        if (((sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) || dateSelectorValue) ===
                            'last30Days')
                            return 'Last 30 days';
                        if (((sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) || dateSelectorValue) ===
                            'last90Days')
                            return 'Last 90 days';
                        if (((sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) || dateSelectorValue) ===
                            'last6Months')
                            return 'Last 6 months';
                        if ([
                            'thisYear',
                            'lastYear',
                            'twoYearsPrior',
                            'threeYearsPrior',
                            'fourYearsPrior',
                            'fiveYearsPrior',
                            'sixYearsPrior',
                        ].includes((sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.selectedDate) || dateSelectorValue))
                            return (sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.endDate)
                                ? sessionPHFilter === null || sessionPHFilter === void 0 ? void 0 : sessionPHFilter.endDate.slice(6, 10)
                                : pHRequest.endDate.slice(0, 4);
                        return '';
                    })()))),
                React.createElement("div", { className: "sui-col-span-1 sui-max-w-[1039px]" },
                    React.createElement(CardAndTableView, { orderHistoryModalHooks: orderHistoryModalHooks, enableSettingsDrawer: enableSettingsDrawer, setEnableSettingsDrawer: setEnableSettingsDrawer })),
                orderHistoryModalHooks.orderHistoryModalComponent))));
};
PurchaseHistory.displayName = 'Purchase History';
